<template lang="pug">
  main
    NavBar
    Loader(v-show="isLoading")
    section.section(v-show="!isLoading")
      .container
        .columns
          .column.is-half.is-offset-one-quarter.has-text-centered
            h1.title Resumen de Combustible&nbsp
              a.button.is-black.is-rounded(@click="backToPage")
                i.fas.fa-times
        .columns
          .column.is-2
            .field
              .control
                flat-pickr(
                  v-model='periodo'
                  :config="config"
                  class="input"
                )
          .column.is-2
            .field
              .control
                input.input.is-dark(
                  type='text', 
                  placeholder='Buscar por Usuario| Cantidad | Fecha ',
                  v-model="query",
                )
          .column.is-5(v-show="!userNormal")
            input#allH.is-checkradio.is-black(type='radio', value='ALL' v-model='filter' checked='checked')
            label.is-size-6(for='allH') Todos
            input#tpaH.is-checkradio.is-black(type='radio', value='TPA' v-model='filter')
            label.is-size-6(for='tpaH') TPA
            input#irgeH.is-checkradio.is-black(type='radio', value='IRGE' v-model='filter')
            label.is-size-6(for='irgeH') IRGE
            input#corpH.is-checkradio.is-black(type='radio', value='CORP' v-model='filter')
            label.is-size-6(for='corpH') CORP.
            input#ductoH.is-checkradio.is-black(type='radio', value='DUCTO' v-model='filter')
            label.is-size-6(for='ductoH') DUCTO
          .column.is-1
            a.button.is-success.is-rounded.is-small(@click="descargarResumen")
              span.icon.is-small
                i.fas.fa-download
              span Resumen
          .column.is-2
            router-link.a.button.is-black.is-rounded.is-small(to="/Transportes/Combustible/Resumen/Nuevo")
              | Nuevo Resúmen
        .columns(v-show="result_query != ''")
          .column.is-offset-8.is-4
            span.tag.is-black.is-small {{ result_query }}
        .columns
          .column.is-12
            Tb_Resumenes(:resumenes="resumenesShow")
        .columns.column-blanco
</template>

<script>
  import NavBar from './layout/NavBarTransportes.vue'
  import Loader from '@/components/shared/Loader.vue'
  import Tb_Resumenes from './componentes/Tb_Resumenes.vue'
  import InventarioServices from '../../services/inventario/inventario'

  import flatPickr from 'vue-flatpickr-component'
  import 'flatpickr/dist/flatpickr.css'
  import { Spanish } from "flatpickr/dist/l10n/es.js"
  
  import moment from 'moment'
  import { mapState } from 'vuex'

  export default {
    name: 'Resumen',
    components: { NavBar, Loader, Tb_Resumenes, flatPickr },
    data() {
      return {
        isLoading: true,
        query: '',
        resumenes: [],
        resumenesShow: [],
        filter: 'ALL',
        periodo: moment().format('YYYY-MM'),
        config: {
          wrap: true, // set wrap to true only when using 'input-group'
          altFormat: 'Y-m',
          altInput: true,
          dateFormat: 'Y-m',
          locale: Spanish, // locale for this instance only          
        },
        result_query: '',
        userNormal: true
      }
    },
    watch: {
      periodo() {
        this.obtenerResumenes()
      },
      query() {
        const QUERY_ARTICULOS = this.query.toUpperCase()
        if (this.query.length !== 0) {
          const resumFilter = this.resumenes.filter( resum => { 
            return `${resum.nombre_usuario} ${resum.ubicacion}`.toUpperCase().includes(QUERY_ARTICULOS)
          }) 
          this.resumenesShow = resumFilter
          this.result_query = this.resumenesShow.length === 1 ? `Se encontró ${this.resumenesShow.length} coincidencia.` : `Se encontraron ${this.resumenesShow.length} coincidencias.`
        } else {
          this.resumenesShow = this.resumenes
          this.result_query = ''
        }
      },
      filter() {
        if (this.filter !== '') {
        console.log('filter')
          if (this.filter === 'ALL') {
            this.resumenesShow = this.resumenes
          } else {
            let resumFilter = []
            switch (this.filter) {
              case 'DUCTO':
                resumFilter = this.resumenes.filter( (resum) => resum.ubicacion === 'EB00' || resum.ubicacion === 'EB01' || resum.ubicacion === 'EB02' || resum.ubicacion === 'EB03' || resum.ubicacion === 'EB04' || resum.ubicacion === 'ERM' || resum.ubicacion === 'LPG_DUCTO')
                this.resumenesShow = resumFilter
                break
              case 'TPA':
                resumFilter = this.resumenes.filter( (resum) => resum.ubicacion === 'TPA')
                this.resumenesShow = resumFilter
                break
              case 'CORP':
                resumFilter = this.resumenes.filter( (resum) => resum.ubicacion === 'CORP')
                this.resumenesShow = resumFilter
                break
              case 'IRGE':
                resumFilter = this.resumenes.filter( (resum) => resum.ubicacion === 'IRGE')
                this.resumenesShow = resumFilter
                break
              default:
                this.resumenesShow = this.resumenes
                break
            }
          }
        }
      }
    },
    methods: {
      iniciarComponente() {
        if (this.userLogin.cargo === '000' || this.userLogin.cargo === '002' || this.userLogin.cargo === '2100' || this.userLogin.cargo === '121' || this.userLogin.cargo === '210' || this.userLogin.cargo === '230' || this.userLogin.cargo === '323' || this.userLogin.cargo === '324') {
          this.userNormal = false
        } 
        this.obtenerResumenes()
      },
      obtenerResumenes() {
        let ubi = this.userNormal ? this.userLogin.ubicacion : 'ALL'
        InventarioServices.getResumenes(this.periodo, ubi, this.userLogin.cargo)
          .then((data) => {
            console.log(data)
            this.resumenes = data
            this.resumenesShow = this.resumenes
            this.isLoading = false
          })
          .catch((e) => {
            console.log(e)
            this.isLoading = false
          })
      },
      descargarResumen () {},
      backToPage () {
        this.$router.back()
      }
    },
    created () {
      this.iniciarComponente()
    },
    computed: {
      ...mapState(['logueado', 'userLogin'])
    }
  }
</script>

<style lang="scss" scoped>
  .column-blanco {
    padding-bottom: 100px;
  }
</style>


// WEBPACK FOOTER //
// src/components/combustibles_Componentes/Resumen.vue